function PageController($el,totalCount,limit,callback){
	this.callback=callback;
	this.el	= $el;
	this.currentPage=0;
	this.totalCount=totalCount;
	this.totalPages=Math.ceil(totalCount/limit);
	this.limit=limit;

	var _this=this;
	this.el.find(".first").click(function(){
		_this.first();
	})
	this.el.find(".prev").click(function(){
		_this.prev();
	})
	this.el.find(".next").click(function(){
		_this.next();
	})
	this.el.find(".last").click(function(){
		_this.last();
	})
	this.gotoPage(this.currentPage);
}

PageController.prototype.gotoPage=function(index){
	this.el.find(".n1").html(index+1);
	this.el.find(".n2").html(this.totalPages);
	if(this.totalPages==0){
		this.el.find(".n2").html(1);
	}
	this.callback(this.limit,this.currentPage*this.limit);
}

PageController.prototype.prev=function(){
	if(this.currentPage>0){
		this.currentPage--;
		this.gotoPage(this.currentPage);
	}
}

PageController.prototype.next=function(){
	if(this.currentPage<this.totalPages-1){
		this.currentPage++;
		this.gotoPage(this.currentPage);
	}
}

PageController.prototype.first=function(){
	this.currentPage=0;
	this.gotoPage(this.currentPage);
}

PageController.prototype.last=function(){
	this.currentPage=this.totalPages-1;
	this.gotoPage(this.currentPage);
}

PageController.prototype.destroy=function(){
	this.el.find(".first").unbind("click");
	this.el.find(".prev").unbind("click");
	this.el.find(".next").unbind("click");
	this.el.find(".last").unbind("click");
	this.callback=null;
	this.el	= null;
}

module.exports=PageController;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/PageController.js
// module id = 11
// module chunks = 2 6